import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class DataRequests extends BaseClass {
  DormantCustomers: BaseClass;
  CustomerContacts: BaseClass;

  constructor(obj: any = PERMISSIONS.DataRequests) {
    super(obj);
    this.DormantCustomers = new BaseClass(obj.DormantCustomers);
    this.CustomerContacts = new BaseClass(obj.CustomerContacts);
  }
}
